import catList from './components/category-list';
import borderList from './components/top50-list';

module.exports = function () {
    console.log('MIC');
    catList();
    borderList();
};
